import { Loader2 } from "lucide-react";

/**
 * Emergent-managed Google Sign-In launcher.
 * Roles: merchant + driver only (admin must use password).
 *
 * REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
 * The redirect must be `${window.location.origin}` + a static path — no query params, no fallbacks.
 *
 * `intent` is the role the visitor wants ("merchant" | "driver"). We stash it
 * in localStorage before the redirect so AuthCallback can route brand-new
 * Google users straight into the right signup form.
 */
export default function GoogleButton({ intent, label = "Continue with Google", className = "" }) {
  const start = () => {
    if (intent) {
      localStorage.setItem("routa_google_intent", intent);
    } else {
      localStorage.removeItem("routa_google_intent");
    }
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/auth/callback";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };
  return (
    <button
      type="button"
      onClick={start}
      data-testid="google-signin-button"
      className={
        "w-full inline-flex items-center justify-center gap-3 border border-gray-300 bg-white text-sm font-semibold text-[#0a0a0a] px-6 py-3 hover:border-[#0a0a0a] hover:bg-gray-50 transition-colors " +
        className
      }
    >
      <GoogleGlyph />
      {label}
    </button>
  );
}

function GoogleGlyph() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 48 48" aria-hidden>
      <path fill="#FFC107" d="M43.6 20.5H42V20H24v8h11.3C33.7 32.8 29.3 36 24 36c-6.6 0-12-5.4-12-12s5.4-12 12-12c3.1 0 5.9 1.2 8.1 3.1l5.7-5.7C34 5.1 29.3 3 24 3 12.4 3 3 12.4 3 24s9.4 21 21 21c11.6 0 21-9.4 21-21 0-1.2-.1-2.3-.4-3.5z"/>
      <path fill="#FF3D00" d="M6.3 14.7l6.6 4.8C14.7 15.9 19 13 24 13c3.1 0 5.9 1.2 8.1 3.1l5.7-5.7C34 5.1 29.3 3 24 3 16.3 3 9.7 7.6 6.3 14.7z"/>
      <path fill="#4CAF50" d="M24 45c5.2 0 9.9-2 13.4-5.2l-6.2-5.2c-2 1.4-4.5 2.4-7.2 2.4-5.2 0-9.6-3.2-11.3-7.7l-6.5 5C9.4 40.4 16.1 45 24 45z"/>
      <path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3c-.8 2.3-2.4 4.2-4.4 5.6l6.2 5.2C41.7 35.9 45 30.4 45 24c0-1.2-.1-2.3-.4-3.5z"/>
    </svg>
  );
}

export function GoogleCallbackLoader() {
  return (
    <div className="min-h-screen bg-white flex items-center justify-center px-6" data-testid="auth-callback-loader">
      <div className="text-center">
        <Loader2 className="mx-auto h-6 w-6 animate-spin text-gray-400" />
        <div className="mt-4 font-mono text-[11px] tracking-[0.18em] uppercase text-gray-400">Signing you in…</div>
      </div>
    </div>
  );
}
